import unescapedText from 'I18n/utils/unescapedText';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { getCopilotFollowUpPrompt } from '../../constants/CopilotFollowUpActionsAllowlist';
export const objectSummaryActionTextParser = (action, teamKey, actionKey) => {
  var _action$objectTypeLab;
  const objectType = (_action$objectTypeLab = action.objectTypeLabel) === null || _action$objectTypeLab === void 0 ? void 0 : _action$objectTypeLab.toLowerCase();
  const followUpActionMessage = teamKey && actionKey && getCopilotFollowUpPrompt(teamKey, actionKey);
  if (action.objectName) {
    if (action.objectTypeId === '0-29') {
      // Specific for emails
      return unescapedText('copilotToolkit.streamingMessage.objectSummary.marketingEmail', {
        objectName: action.objectName
      });
    }
    if (followUpActionMessage) {
      const isValidFollowUpKey = isValidI18nKey(`copilotToolkit.streamingMessage.objectSummary.tellAbout.${objectType}.withFollowUp`);
      return unescapedText(isValidFollowUpKey ? `copilotToolkit.streamingMessage.objectSummary.tellAbout.${objectType}.withFollowUp` : `copilotToolkit.streamingMessage.objectSummary.tellAbout.default`, {
        objectName: action.objectName,
        followUpMessage: followUpActionMessage
      });
    }

    // Use object-specific translation keys instead of a generic one with parameters
    const isValidKey = isValidI18nKey(`copilotToolkit.streamingMessage.objectSummary.tellAbout.${objectType}.baseText`);
    return unescapedText(isValidKey ? `copilotToolkit.streamingMessage.objectSummary.tellAbout.${objectType}.baseText` : `copilotToolkit.streamingMessage.objectSummary.tellAbout.default`, {
      objectName: action.objectName
    });
  }
  if (action.label) {
    if (followUpActionMessage) {
      const isValidFollowUpKey = isValidI18nKey(`copilotToolkit.streamingMessage.objectSummary.summarize.${objectType}.withFollowUp`);
      return unescapedText(isValidFollowUpKey ? `copilotToolkit.streamingMessage.objectSummary.summarize.${objectType}.withFollowUp` : `copilotToolkit.streamingMessage.objectSummary.summarize.default`, {
        label: action.label,
        followUpMessage: followUpActionMessage
      });
    }
    const isValidKey = isValidI18nKey(`copilotToolkit.streamingMessage.objectSummary.summarize.${objectType}.baseText`);
    return unescapedText(isValidKey ? `copilotToolkit.streamingMessage.objectSummary.summarize.${objectType}.baseText` : `copilotToolkit.streamingMessage.objectSummary.summarize.default`, {
      label: action.label
    });
  }
  const isValidKey = isValidI18nKey(`copilotToolkit.streamingMessage.objectSummary.tellAboutUnknown.${objectType}`);
  return unescapedText(isValidKey ? `copilotToolkit.streamingMessage.objectSummary.tellAboutUnknown.${objectType}` : `copilotToolkit.streamingMessage.objectSummary.tellAboutUnknown.default`);
};